import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';

export enum EQuestionnaireHeaderColumnEnum {
  TITLE = 'title',
  CREATED_BY = 'createdBy',
  CREATED_AT = 'createdAt',
  ACTIONS = 'actions',
}

export type TQuestionnaireHeaderColumn = keyof typeof EQuestionnaireHeaderColumnEnum;

export const getQuestionnaireHeaderColumns = (enabledColumns: EQuestionnaireHeaderColumnEnum[]) => {
  const columns: IHeaderColumn<EQuestionnaireHeaderColumnEnum>[] = [];

  enabledColumns.forEach(column => {
    switch (column) {
      case EQuestionnaireHeaderColumnEnum.TITLE:
        columns.push({
          id: EQuestionnaireHeaderColumnEnum.TITLE,
          headerName: 'Title',
          sortable: false,
          align: 'left',
        });
        break;

      case EQuestionnaireHeaderColumnEnum.CREATED_BY:
        columns.push({
          id: EQuestionnaireHeaderColumnEnum.CREATED_BY,
          headerName: 'Created by',
          sortable: false,
          align: 'center',
        });
        break;

      case EQuestionnaireHeaderColumnEnum.CREATED_AT:
        columns.push({
          id: EQuestionnaireHeaderColumnEnum.CREATED_AT,
          headerName: 'Date created',
          sortable: false,
          align: 'center',
        });
        break;

      case EQuestionnaireHeaderColumnEnum.ACTIONS:
        columns.push({
          id: EQuestionnaireHeaderColumnEnum.ACTIONS,
          headerName: 'Actions',
          sortable: false,
          align: 'right',
        });
    }
  });

  return columns;
};
